export const CLASS_TIMING_LIST_REQ = "CLASS_TIMING_LIST_REQ";
export const CLASS_TIMING_LIST_SUCCESS = "CLASS_TIMING_LIST_SUCCESS";
export const CLASS_TIMING_LIST_FAILED = "CLASS_TIMING_LIST_FAILED";


export const CLASS_MODE_LIST_REQ = "CLASS_MODE_LIST_REQ";
export const CLASS_MODE_LIST_SUCCESS = "CLASS_MODE_LIST_SUCCESS";
export const CLASS_MODE_LIST_FAILED = "CLASS_MODE_LIST_FAILED";
